/* eslint-disable @cspell/spellchecker */
import { initializeApp } from 'firebase/app';
import * as firebaseRemoteConfig from 'firebase/remote-config';
import { useState } from 'react';

import { defaultConfig, type ConfigContextType } from '../ConfigProvider';

const firebaseApiKey = import.meta.env.VITE_APP_FIREBASE_API_KEY;
const firebaseConfig = {
  apiKey: firebaseApiKey,
  authDomain: import.meta.env.VITE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_APP_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_APP_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_APP_FIREBASE_MEASUREMENT_ID,
};

function toRemoteDefaultConfig(defaultConfig: ConfigContextType) {
  const remoteDefaultConfig: firebaseRemoteConfig.RemoteConfig['defaultConfig'] = {};
  Object.entries(defaultConfig).forEach(([key, value]) => {
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
      remoteDefaultConfig[key] = value;
    } else {
      remoteDefaultConfig[key] = JSON.stringify(value);
    }
  });
  return remoteDefaultConfig;
}

// function resolveValue(remoteConfigValue: string) {
//   const remoteConfigValueAsNumber = Number(remoteConfigValue);
//   // Check is number
//   if (!Number.isNaN(remoteConfigValueAsNumber)) return remoteConfigValueAsNumber;

//   try {
//     const remoteConfigValueAsJSON = JSON.parse(remoteConfigValue);
//     return remoteConfigValueAsJSON;
//   } catch (error) {
//     console.error('Firebase Remote Config failed to parse value', error);
//     return remoteConfigValue;
//   }
// }

// Initialize Firebase only if configured
if (firebaseApiKey) {
  const firebase = initializeApp(firebaseConfig);
  const remoteConfig = firebaseRemoteConfig.getRemoteConfig(firebase);

  remoteConfig.settings.minimumFetchIntervalMillis =
    import.meta.env.MODE === 'prod' || import.meta.env.MODE === 'staging' ? 0 : 3600000;
  remoteConfig.defaultConfig = toRemoteDefaultConfig(defaultConfig);
}

function useFirebaseRemoteConfig() {
  const [config] = useState<ConfigContextType>(defaultConfig);

  // TODO: SET eExam - confirm if we wanna use Firebase Remote Config
  // useEffect(() => {
  //   async function initialRemoteConfig() {
  //     await firebaseRemoteConfig.ensureInitialized(remoteConfig);
  //     await firebaseRemoteConfig.fetchAndActivate(remoteConfig);
  //     const remoteConfigValues = firebaseRemoteConfig.getAll(remoteConfig);

  //     const appConfigValue: Partial<Config> = {};
  //     Object.entries(remoteConfigValues).forEach(([key, value]) => {
  //       const remoteConfigValue = (value as firebaseRemoteConfig.Value & { _value: string })._value;
  //       const resolvedConfig = resolveValue(remoteConfigValue);
  //       appConfigValue[key as keyof Config] = resolvedConfig;
  //     });
  //     const mergedConfig = merge({}, defaultConfig, appConfigValue);

  //     setConfig(mergedConfig as ConfigContextType);
  //   }

  //   initialRemoteConfig().catch((error: Error) => {
  //     console.error('Firebase Remote Config failed to initialize', error);
  //     setConfig({ ...defaultConfig, appState: APP_STATE.MAINTENANCE });
  //   });
  // }, []);

  return { config };
}

/**
 * Fetches a configuration value from Firebase Remote Config by a given key.
 * Suitable for use outside React components.
 */
export function getRemoteConfigValue(key: string): string {
  if (!firebaseApiKey) return '';

  const remoteConfig = firebaseRemoteConfig.getRemoteConfig();
  const value = firebaseRemoteConfig.getValue(remoteConfig, key);
  return value.asString();
}

export default useFirebaseRemoteConfig;
